import { PiWarningCircleThin } from "react-icons/pi";
import { Button } from "../Button";
import type { ModalProps } from "./interface";
import { useModal } from "./useModal";

export function Modal({
  isOpen,
  onClose,
  onConfirm,
  title = "Tem certeza?",
  children,
  confirmText = "Confirmar",
  cancelText = "Cancelar",
  variant = "danger",
}: ModalProps) {
  const { handleBackdropClick, styles } = useModal({ variant, onClose });

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-black/20 flex items-center justify-center z-50 p-4"
      onClick={handleBackdropClick}
    >
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4">
        {/* Header */}
        <div className="p-5 pb-4">
          <div className="flex items-center gap-1">
            <PiWarningCircleThin className={`text-xl ${styles.iconColor}`} />
            <h2 className="text-lg font-semibold text-[16px]">{title}</h2>
          </div>
        </div>

        {/* Content */}
        <div className="px-6 pb-6 mt-2">
          <div className="text-sm">{children}</div>
        </div>

        {/* Footer */}
        <div className="px-6 py-4 bg-white rounded-b-lg flex gap-3 justify-end">
          <Button onClick={onClose} variant="no-border-danger" size="large">
            {cancelText}
          </Button>
          <Button onClick={onConfirm} variant="danger" size="large">
            {confirmText}
          </Button>
        </div>
      </div>
    </div>
  );
}
